/* eslint-disable camelcase */
import React from 'react';

import { Headline, Author, DetailsShort, HeaderImage, Content, DisqusWrapper } from '../atoms';

const BlogPost = (data, uid) => {
  const { blog_headline, author, tags, blog_post_date, blog_header_image, blog_post_content } = data;

  return (
    <div>
      {Headline(blog_headline, uid)}
      {DetailsShort(tags, blog_post_date, '', blog_headline, uid)}
      {HeaderImage(blog_header_image)}
      {Author(author)}
      {Content(blog_post_content)}
      {DisqusWrapper(blog_headline, uid, 'comments')}
    </div>
  );
};

export default BlogPost;
